module.exports = __webpack_public_path__ + "pic5.4e67035d3b74f5662b4f.jpg";


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/assets/img/pic5.jpg
// module id = ../../../../../src/assets/img/pic5.jpg
// module chunks = main